import styles from 'styled-components';

const StyledHeading = styles.h2``;

const Heading2 = ({ children, ...rest }) => (
  <StyledHeading {...rest}>{children}</StyledHeading>
);

export default Heading2;
